import React from 'react';
import Observable from './Observable';
function IoElement({ 
// isServer = false,
onIntersect, exitCallBack, children, onIntersectV2, className, childClassName, rootMargin, isV2Present = true, }) {
    // if (isServer) {
    //   return children;
    // }
    return (React.createElement(Observable, { className: className, childClassName: childClassName, onIntersect: onIntersect, exitCallBack: exitCallBack, onIntersectV2: onIntersectV2, rootMargin: rootMargin, isV2Present: isV2Present }, children));
}
export default IoElement;
